import router from '@/router';
import Cookies from 'js-cookie';
import { app } from '@/main';
import Config from '@/config';

// Check for the Error response which can't be handled by the caller, like internal server Errors
// or unauthorized Errors. API client middlewares cannot change execution flow. Even though we redirect
// still the caller components will continue to be executed. This is why we have to return the response.
export function onHttpError(err) {
  const response = err.response;
  if (!response) {
    app.$message.error(app.$t('Error Occurred'));
    console.error('Request error');
    throw 'API connection error: Can not access to API.';
  }
  if (response?.data?.message && !!response?.data?.message?.length)
    app.$message.error(response.data.message);

  switch (response.status) {
    /*
         Unauthorized request has been made, redirect user to login page
         */
    case 401:
      Cookies.remove('mo_access_token', { path: Config.cookiePath });
      router.push('/login').catch(() => {});
      break;

    /*
         Error caused by RBAC error.
         */
    case 403:
      // Wrong access token
      if (response.data.description === 'Invalid token') {
        Cookies.remove('mo_access_token', { path: Config.cookiePath });
        router.push('/login').catch(() => {});
      }

      // No permission
      if (response.data.description === 'No permission(s) found') {
        // No permission -> Can't get user information
        if (response.config.url === `${response.config.baseURL}/user`) {
          router.push('/errorAccessDeny').catch(() => {});
          throw "Can't get user information";
        }

        // No permission -> Method is 'GET'.
        if (response.config.method === 'get') {
          throw 'No permission';
        }

        // No permission -> Method is 'POST/ PUT / PATCH / DELETE'.
        if (response.config.method !== 'get') {
          app.$message.error('権限がありません');
          throw 'No permission';
        }
      }
      break;

    /*
         Error caused by the server return 404 error.
         */
    case 404:
      // router.push('/error');
      break;

    /*
         Error caused by the server show Error page, frontend can't handle this Error
         */
    case 500:
      router.push('/500').catch(() => {});
      break;
  }

  return Promise.reject(err);
}
